import { ISearchParameters, ITableReport } from "./TableInterfaces";

export interface ISizeIncreaseTableReport extends ITableReport {}

export interface ISizeDecreaseTableReport extends ITableReport {}

export interface IDeltaClosureTableReport extends ITableReport {}

export interface IDecrementalTableReport extends ITableReport {
  baseInsId: string;
  minBubble: number;
  canSellBaseIns: boolean;
  margin: number;
}

export interface IIncrementalTableReport extends ITableReport {
  baseInsId: string;
  maxBubble: number;
  canBuyBaseIns: boolean;
  buyCallOptionJustInOffsetMode: boolean;
  minCoverage: number;
  margin: number;
}

export interface IOptionOptimizationTableReport extends ITableReport {}

export interface IDeltaHedgeTablesSearchParam extends ISearchParameters {
  baseInsId: string;
  InsId: string;
}

export enum DeltaHedgeMode {
  Concurrent = 1,
  OneByOne = 2,
}
